import { ColorPicker } from '@src/components/ui';
import { ICommonFormProps } from '../DynamicForm.types';
import { isFormValidationError } from '@src/utilities/form';

export function FormColorPicker(props: ICommonFormProps) {
    const { defaultValue, inputProperties } = props || {};
    const { size, ...inputProps } = inputProperties || {};

    const colorDefaultValue =
        typeof defaultValue === 'string' ? defaultValue : undefined;

    return (
        <div className="w-full h-full">
            <ColorPicker
                size="small"
                disabled={props.disabled || false}
                data-component-name={props.keyName}
                className={props.className}
                inputProps={{
                    ...inputProps,
                    size: size,
                    placeholder: props.inputProperties?.placeholder || '',
                    isRequired:
                        typeof props.registerOptions?.required === 'object'
                            ? Boolean(props.registerOptions.required.value)
                            : Boolean(props.registerOptions?.required),
                    defaultValue: props.formProps?.defaultValue,
                    maxLength: props.formProps?.maxLength,
                    showCount: props.formProps?.showCount,
                    addonBefore: props.formProps?.addonBefore,
                    label:
                        typeof props.label === 'string'
                            ? props.label
                            : (props.label as React.ReactNode),
                    error: props.errors
                        ? isFormValidationError(props.errors.type)
                            ? props.errors?.message
                            : `${props.label} ${props.errors.type}`
                        : undefined,
                    help:
                        typeof props.formProps?.help === 'string'
                            ? props.formProps?.help
                            : props.formProps?.help,
                    onBlur: props.formProps?.onBlur ?? props.field?.onBlur,
                }}
                value={props.field?.value || '#2E2E2E'}
                defaultValue={colorDefaultValue}
                onChange={(_, value) => {
                    if (props.formProps?.onChange) {
                        props.formProps.onChange({ target: { value } });
                    }
                    if (props.setValue) {
                        props.setValue(props.keyName, value);
                        props.triggerValidation!(props.keyName);
                    }
                    props.field?.onChange(value);
                }}
                onInputChange={(value) => {
                    const normalized = value.startsWith('#')
                        ? value
                        : `#${value}`;

                    props.field?.onChange(normalized);
                }}
            />
        </div>
    );
}
